import React from "react"

import { RoomInput } from "entities/rooms/ui"

import { useProductPositionFormCoreContext } from "../../contexts/ProductPositionFormCoreContext"
import { useProductPositionFormLoadingContext } from "../../contexts/ProductPositionFormLoadingContext"
import { useProductPositionFormSelectionContext } from "../../contexts/ProductPositionFormSelectionContext"

export const ProductPositionRoomInput = React.memo(() => {
  const { isReadonly, isDisabled, formOptions } =
    useProductPositionFormCoreContext()
  const { isLoadingParentOptions } = useProductPositionFormLoadingContext()
  const { roomOptions } = useProductPositionFormSelectionContext()
  const { hideParentSelection } = formOptions || {}

  if (isReadonly || !roomOptions || hideParentSelection) return null

  return (
    <RoomInput
      name="parentID"
      options={roomOptions}
      readonly={isReadonly}
      loading={isLoadingParentOptions}
      disabled={isDisabled}
    />
  )
})
